export default "__VITE_ASSET__CqSrsXE9__"